import { ascend, pipe, propOr, sort } from 'ramda'

const classroomParser = pipe(sort(ascend(propOr(0, 'startTime'))))

export default classroomParser
